import { BuildingState, BuildingType } from '../types';
import { TILE } from '../constants';

// Building is mostly data; rendering handled by renderer.ts
// This file provides utility functions

export function getBuildingAABB(b: BuildingState): { x: number; y: number; w: number; h: number } {
  return {
    x: b.gridX * TILE,
    y: b.gridY * TILE,
    w: TILE,
    h: TILE,
  };
}

export function isCellOccupied(gridX: number, gridY: number, buildings: BuildingState[]): boolean {
  return buildings.some(b => b.gridX === gridX && b.gridY === gridY);
}
